module.exports = __webpack_public_path__ + "static/media/AboutsecondWitness.22bc29d2.webp";